import LocalTime from 'local-time'
import StripeCheckoutButton from './stripe_checkout_buttons'
import Admin from './admin/plans'

LocalTime.start()
